export default __webpack_public_path__ + "08d13ca9f891690266ba2d0806769d98.png";